var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col text-center" },
        [
          !this.loading
            ? _c(_vm.simpleComponent, {
                key: "simple-sign",
                tag: "component",
                attrs: {
                  user: _vm.user,
                  "sign-configuration": _vm.signConfiguration,
                  requestData: _vm.requestData,
                  ambit: _vm.ambit
                },
                on: { activate: _vm.activationReload, cancel: _vm.cancel }
              })
            : _vm._e(),
          this.loading
            ? _c("b-spinner", { attrs: { small: "", variant: "primary" } })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }